import { useContext, useEffect } from "react";
import { RequestResponse } from "@/services/api/request/contracts";
import { logger } from "@/utils";
import { useRequestState } from "@/hooks";
import { UseRequestDataProps } from "@/pages/requests/types";
import { AuthContext } from "@/guards/auth/auth-context";
import { requestInboxDetails } from "@/services/api/inbox/requests";

export const useRequestData = ({
  referenceNumber,
  domainId,
  resetRequestFormData,
  onResetForm,
  onSetStep,
}: UseRequestDataProps) => {
  const { account } = useContext(AuthContext);

  const { isLoading, data, error, setSuccess, setError } =
    useRequestState<RequestResponse>({
      isLoading: true,
    });

  useEffect(() => {
    const controller = new AbortController();

    if (referenceNumber && domainId) {
      requestInboxDetails(
        { email: account?.username ?? "", referenceNumber, domainId },
        { signal: controller.signal },
      )
        .then(response => {
          setSuccess(response.Data);
        })
        .catch(error => {
          setError(error);
          logger.error(error);
        });
    } else {
      resetRequestFormData();
      onResetForm();
      onSetStep(0);
    }

    return () => {
      controller.abort();
    };
  }, [
    account,
    referenceNumber,
    onResetForm,
    resetRequestFormData,
    setError,
    setSuccess,
    domainId,
    onSetStep,
  ]);

  return {
    isLoading,
    data,
    error,
  };
};
